import { debounce } from "../../../_src/js/Util";

App.document.ready(() => {
    const resultDefault = $resultSearch.html();

    $(".js-header-search-open").on("click", function () {
        $(".js-header-search-input").val("");
        App.H.addClass("_search-opened");
        App.lockScroll.lock();
    });
    $(".js-header-search-close").on("click", function () {
        $(".js-header-search-input").val("");
        $(".js-header-search").removeClass("_filled");
        App.H.removeClass("_search-opened");
        App.lockScroll.unlock();
        $resultSearch.html(resultDefault);
    });

    $(".js-header-search-input").on("input", function () {
        if ($(this).val().length > 0) {
            $(this).closest(".js-header-search").addClass("_filled");
        } else {
            $(this).closest(".js-header-search").removeClass("_filled");
        }
    });

    App.H.on("click", function (e) {
        if (
            App.H.hasClass("_search-opened") &&
            !$(this).hasClass(".js-header-search") &&
            !$(e.target).parents().addBack().is(".js-header-search") &&
            !$(this).hasClass(".js-header-search-results") &&
            !$(e.target).parents().addBack().is(".js-header-search-results") &&
            !$(this).hasClass(".js-header-search-open") &&
            !$(e.target).parents().addBack().is(".js-header-search-open")
        ) {
            $(".js-header-search-input").val("");
            $(".js-header-search").removeClass("_filled");
            App.H.removeClass("_search-opened");
            App.lockScroll.unlock();
            $resultSearch.html(resultDefault);
        }
    });
});

const funcSearch = debounce((e) => {
    let searchVal = e.target.value;
    const $form = $(e.target).closest(".js-search-form");

    if (searchVal !== "" && searchVal.length > 1) {
        $.ajax({
            url: $form.attr("action"),
            method: $form.attr("method") || "GET",
            data: $form.serialize(),
            success: function (res) {
                $resultSearch.empty();
                $resultSearch.html(res.html);
                if (res.success) {
                    $resultSearch.empty();
                    $resultSearch.html(res.html);
                } else {
                    $resultSearch.empty();
                    $resultSearch.html(res.message);
                }
            },
        });
    } else {
        $resultSearch.html("");
    }
}, 150);

const $search = $(".js-header-search-input");
const $resultSearch = $(".js-header-search-results");

$search.on("keyup", function (e) {
    funcSearch(e);
});
